import { type ReactNode } from 'react';
import { Loader as LoaderIcon } from 'react-loaders';

interface LoaderProps {
  children?: ReactNode;
  isLoading: boolean;
  message?: string | null;
}

const Loader = ({ children = null, isLoading, message = null }: LoaderProps) =>
  isLoading ? (
    <div className="z-1" data-testid="page-loader" id="loader">
      <LoaderIcon active className="loader-dark" color="#FCC015" type="line-scale" />
      {message && <span className="loader--message">{message}</span>}
    </div>
  ) : (
    children
  );

export default Loader;
